/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editpicture1Inputs */

const en_editpicture1 = /** @type {(inputs: Editpicture1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Picture`)
};

const de_editpicture1 = /** @type {(inputs: Editpicture1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit Picture" |
*
* @param {Editpicture1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editpicture1 = /** @type {((inputs?: Editpicture1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editpicture1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editpicture1(inputs)
	return de_editpicture1(inputs)
});
export { editpicture1 as "editPicture" }